export default '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\
  <path d="M18.7 5.645L10.03 14.316L1.359 5.645" stroke="var(--color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>'
